import { ITask } from '../../models/';
import * as TASK from './tasks.constants';

export function loadTasks() {
    return { type: TASK.TASKS_LOAD };
}

export function loadTasksSuccess(data: ITask[]) {
    return { type: TASK.TASKS_LOAD_SUCCESS, payload: data };
}

export function loadTasksError(reason: any) {
    return { type: TASK.TASKS_LOAD_ERROR, payload: reason };
}

export function deleteTasksCompleted() {
    return { type: TASK.TASKS_DELETE_COMPLETED };
}

export function deleteTasksCompletedSuccess(data: ITask[]) {
    return { type: TASK.TASKS_DELETE_COMPLETED_SUCCESS, payload: data };
}

export function deleteTasksCompletedError(reason: any) {
    return { type: TASK.TASKS_DELETE_COMPLETED_ERROR, payload: reason };
}

export function loadTaskSuccess(data: ITask) {
    return { type: TASK.TASK_LOAD_SUCCESS, payload: data };
}

export function loadTaskError(reason: any) {
    return { type: TASK.TASK_LOAD_ERROR, payload: reason };
}

export function addTask() {
    return { type: TASK.TASK_ADD };
}

export function addTaskSuccess(data: ITask) {
    return { type: TASK.TASK_ADD_SUCCESS, payload: data };
}

export function addTaskError(reason: any) {
    return { type: TASK.TASK_ADD_ERROR, payload: reason };
}